import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as LayoutLeftIcon } from '../../../icons/layout-left.svg';
import { ReactComponent as SettingsIcon } from '../../../icons/nav-links/settings.svg';
import { ReactComponent as WhatsappIcon } from '../../../icons/whatsapp-color.svg';
import { useAgentWhatsappNumber } from '../../../hooks/useAgentWhatsappNumber';
import { settingsLinkState } from '../../../utils/settingsReturn';
import './mobile-app-shell.scss';

interface MobileAppHeaderProps {
  title: string;
  onOpenMenu: () => void;
  /** Extra app-specific actions rendered before Settings (e.g. delete app). */
  actions?: React.ReactNode;
}

/**
 * Compact header shown above every Global App on mobile (Figma 5227:17435):
 * apps-menu button, app title, then Settings and WhatsApp shortcuts.
 */
const MobileAppHeader: React.FC<MobileAppHeaderProps> = ({
  title,
  onOpenMenu,
  actions,
}) => {
  const { whatsappLink } = useAgentWhatsappNumber();
  const location = useLocation();

  return (
    <header className='mobile-app-header' data-testid='mobile-app-header'>
      <button
        type='button'
        className='mobile-app-header-btn mobile-app-header-menu-btn'
        onClick={onOpenMenu}
        aria-label='Open apps menu'
      >
        <LayoutLeftIcon />
      </button>
      <h1 className='mobile-app-header-title'>{title}</h1>
      <div className='mobile-app-header-actions'>
        {actions}
        <Link
          to='/settings'
          state={settingsLinkState(location)}
          className='mobile-app-header-btn'
          aria-label='Settings'
        >
          <SettingsIcon />
        </Link>
        {whatsappLink && (
          <a
            href={whatsappLink}
            target='_blank'
            rel='noreferrer'
            className='mobile-app-header-btn mobile-app-header-whatsapp'
            aria-label='Chat on WhatsApp'
          >
            <WhatsappIcon />
          </a>
        )}
      </div>
    </header>
  );
};

export default MobileAppHeader;
